import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { EligibilityLogsComponent } from './eligibility-logs.component';
import { EligibilityLogsRoutingModule } from './eligibility-logs-routing.module';
@NgModule({
  declarations: [EligibilityLogsComponent],
  exports:[EligibilityLogsComponent],
  imports: [
    CommonModule,
    GridModule,
    EligibilityLogsRoutingModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    FormsModule,
    ReactiveFormsModule,
    MyDatePickerModule
  ],
  providers:[ PageService,
    SortService,
    ResizeService,
    FilterService,ColumnChooserService]
})
export class EligibilityLogsModule { }
